import { SearchLocationAutocomplete, SearchLocationAutocompleteProps } from 'features/location';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';

type ConnectedLocationAutocompleteProps<TFieldValues extends FieldValues, Multiple extends boolean = false> = 
    Omit<SearchLocationAutocompleteProps<Multiple>, 'onChange' | 'value'> &
    UseControllerProps<TFieldValues>;

export default function ConnectedLocationAutocomplete<TFieldValues extends FieldValues, Multiple extends boolean = false>({ 
    control,
    name,
    rules,
    ...rest
}: ConnectedLocationAutocompleteProps<TFieldValues, Multiple>) {
    return (
        <Controller 
            name={ name }
            control={ control }
            rules={ rules }
            render={ ({ field: { ref, ...field }, fieldState }) => (
                <SearchLocationAutocomplete<Multiple> 
                    { ...field }
                    error={ Boolean(fieldState.error?.message) }
                    helperText={ fieldState.error?.message }
                    inputRef={ ref }
                    { ...rest }
                />
            ) }
        />
    );
}
